import { useContext } from "react";
import { useAuth } from "../../auth/useAuth";
import { HttpMethods } from "../../data/HttpMethods";
import { NotificationTypes } from "../../data/NotificationTypes";
import { AcceptanceDto } from "../../dtos/AcceptanceDto";
import VillageConsoleContext from "../../store/VillageConsoleContext";
import { getHttpOptions, fetchData } from "../../utils/http.util";
import { ResidentDto } from "./dtos/ResidentDto";
import { Domains } from "../../data/Domains";


export const useFindAcceptances = ( ): {
    
    getAcceptancePdf( acceptanceId: number, domain: Domains, errorMessage: string ): Promise< string | undefined >
    , getAcceptances( residentDto: ResidentDto ): Promise< AcceptanceDto[ ] >

} => {

    const { functionKey, setNotificationText, setNotificationType } = useContext( VillageConsoleContext );
    const { getIdToken } = useAuth( );

    
    const getAcceptancePdf = async ( acceptanceId: number, domain: Domains, errorMessage: string ): Promise< string | undefined > => {

        const query = `${process.env.REACT_APP_API_URL}/acceptance-pdf?domain=${ domain }&acceptanceId=${ acceptanceId }`
        const idToken: string = await getIdToken( );
        const options = getHttpOptions ( idToken, functionKey!, HttpMethods.Get );

        const response = await fetchData( options, query  );

        if ( response.statusCode !== 200 ) {

            setNotificationType( NotificationTypes.Error );
            setNotificationText( errorMessage );
            return undefined;

        }

        return await response.response?.text( );

    };

    const getAcceptances = async ( residentDto: ResidentDto ): Promise<AcceptanceDto[]> => {


        const query = `${process.env.REACT_APP_API_URL}/acceptances?domain=${ residentDto.domain }&employeeId=${ residentDto.employeeId }&firstName=${ residentDto.firstName }&lastName=${ residentDto.lastName }`
        const idToken: string = await getIdToken( );
        const options = getHttpOptions ( idToken, functionKey!, HttpMethods.Get );
  
        const response = await fetchData( options, query  );

        if ( response.statusCode !== 200 ) {

            setNotificationType( NotificationTypes.Error );
            setNotificationText( `Error fetching ${ residentDto.domain } acceptances` );
            return [];

        }

        return await response.response?.json( );

    };


    return {
    
        getAcceptancePdf
        , getAcceptances

    };

}